import { Reducer } from 'react';
import { handleReducer } from './index';
import { IAdNative, IAdState } from 'src/interface';
import { ACTIONS } from '../actions/ad/dispatchActions';

const STATE_DEFAULT: IAdState = {} as IAdState;

const handler = {
    [ACTIONS.AD_NATIVE_UPDATE]: (
        state: IAdState,
        {
            prZoneIds,
            adData,
        }: {
            prZoneIds: string[];
            adData: IAdNative;
        }
    ): IAdState => {
        return {
            ...state,
            prZoneIds,
            native: adData,
        };
    },
    [ACTIONS.IS_NOAD_UPDATE]: (state: IAdState, isNoAd: boolean): IAdState => {
        return {
            ...state,
            native: {},
            prZoneIds: [],
            isNoAd,
        };
    },
};

const adReducer: Reducer<any, any> = (state = STATE_DEFAULT, action: any) => {
    return handleReducer(handler, state, action);
};

export default adReducer;
